/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import style from "./DetailContainer.module.scss";
import { BsBriefcase, BsThreeDotsVertical, BsWhatsapp } from "react-icons/bs";
import { FaArrowLeft } from "react-icons/fa6";

import {
  IoAlarmOutline,
  IoLocationOutline,
  IoMailOutline,
} from "react-icons/io5";
import candiateImage from "../../assets/images/person.png";
import {
  MdOutlineContentCopy,
  MdOutlineLocalPhone,
  MdUpdate,
} from "react-icons/md";
import { LuCalendarCheck2 } from "react-icons/lu";
import {
  copyToClipboard,
  decryptedAdminID,
  dialPhoneNumber,
  formatDateTime,
  openWhatsApp,
  sources,
  textTruncate,
} from "../../utility";
import { SlGraduation } from "react-icons/sl";
import { FiPhone } from "react-icons/fi";
import { BiMessageRoundedDetail } from "react-icons/bi";
import CandidateTabs from "./Tabs/CandidateTabs";
import {
  getAdminIds,
  getCandidateDetails,
  updateCandidate,
} from "../../services/candidateServices";
import Loader from "../Common/Loader/Loader";
import ScheduleInterview from "../../pages/NewPipeline/InterviewPipeline/InterviewCreate/ScheduleInterview";
import TimelineView from "./Tabs/TabsData/Timeline";
import { AiOutlineClose } from "react-icons/ai";
import { Autocomplete, MenuItem, Popover, TextField } from "@mui/material";
import { MyModal } from "../Common/Model/MyModal";
import ModalContainer from "../Common/Model/ModalContainer";
import SuccessTick from "../success_tick";
import { IoMdCheckmarkCircle } from "react-icons/io";
import CreateFollowUp from "../../pages/NewFollowUp/CreateFollowUp";
import { useSelector } from "react-redux";
import { GetCandidateQualifyForm, PutCandidateType } from "../../apiServices";
import UpdateFresherForm from "../../pages/Candidate/CandidateUpdateQualifyForm/UpdateFresherForm";
import UpdateExperienceForm from "../../pages/Candidate/CandidateUpdateQualifyForm/UpdateExperienceForm";
import { LiaUserEditSolid } from "react-icons/lia";
import FormMainLayout from "../../pages/Candidate/NewCandidateForm/FormMainLayout";

function DetailContainer({ candidateid, canLeadid, onBack }) {
  // const { id } = useParams();
  const id = candidateid || canLeadid;
  console.log(id, "idid");

  const isLead =
    canLeadid !== null && canLeadid !== undefined && canLeadid !== "";
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails?.roleID === 1;

  const isTeamLeader = localStorage.getItem("teamLeader") == "true";

  const [mainTab, setMainTab] = useState("Overview");
  const [innerTab, setInnerTab] = useState("Summary");

  const [basicData, setBasicData] = useState(null);
  const [resumeData, setResumeData] = useState(null);
  const [interviewData, setInterviewData] = useState(null);

  const [loadedTabs, setLoadedTabs] = useState({});
  const [loading, setLoading] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openSuccessFollowUp, setOpenSuccessFollowUp] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const [currentAdminId, setCurrentAdminId] = useState(null);
  const [isEmailIdEditing, setIsEmailIdEditing] = useState(false);
  const [openFollowUp, setOpenFollowUp] = useState(false);

  const [sourceOpen, setSourceOpen] = useState(false);
  const [selectedSource, setSelectedSource] = useState(null);

  const [emailState, setEmailState] = useState({
    value: "",
    error: "",
  });

  const [assignOpen, setAssignOpen] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const location = useLocation();

  const [selectedOption, setSelectedOption] = useState("");
  const [oponUpdateForm, setoponUpdateForm] = useState(false);
    const [oponUpdateFormNew, setoponUpdateFormNew] = useState(false);
  const [candiateDetails, setCandidateDetails] = useState({});

  // const previousTab = location.state?.tab || "active";

  const previousMainTab = location.state?.mainTab || "Interview";
  const previousSubTab = location.state?.subTab || "active";
  console.log(previousMainTab, "previousMainTab");

  // ✅ API CALL
  const fetchCandidate = async (type) => {
    try {
      setLoading(true);

      const res = await getCandidateDetails(id, type, isLead);

      if (type === "basicDetails") {
        setBasicData(res?.data?.[0] || null);
      }

      if (type === "candidateDocuments") {
        setResumeData(res?.data || []);
      }

      if (type === "interviewDetails") {
        setInterviewData(res?.data || []);
      }

      setLoadedTabs((prev) => ({
        ...prev,
        [type]: true,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Initial Load
  useEffect(() => {
    if (id && !loadedTabs["basicDetails"]) {
      fetchCandidate("basicDetails");
    }
  }, [id]);

  // ✅ Tab-based API (only once)
  useEffect(() => {
    if (!id || mainTab !== "Overview") return;

    if (innerTab === "Resume" && !loadedTabs["candidateDocuments"]) {
      fetchCandidate("candidateDocuments");
    }
    if (innerTab === "Interviews" && !loadedTabs["interviewDetails"]) {
      fetchCandidate("interviewDetails");
    }
  }, [innerTab]);
  const refreshResume = () => {
    fetchCandidate("candidateDocuments");
  };

  const reloadInterviews = () => {
    fetchCandidate("interviewDetails");
  };

  const handleMenuClick = (event, adminId) => {
    setAnchorEl(event.currentTarget);
    setCurrentAdminId(adminId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEmailChange = (value) => {
    setEmailState({
      value,
      error: "",
    });
  };

  const handleSourceChange = (_, value) => {
    setSelectedSource(value);
  };

  //   const getIdPayload = () => {
  //   return isLead
  //     ? { can_lead_id: normalizedCandidate?.id }
  //     : { can_id: normalizedCandidate?.candidate_id };
  // };


  const handleEmailSubmit = async () => {
    const email = emailState.value.trim();

    // validation
    if (!email) {
      setEmailState((prev) => ({
        ...prev,
        error: "Email Id is required",
      }));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setEmailState((prev) => ({
        ...prev,
        error: "Enter valid Email Id",
      }));
      return;
    }
    console.log(email, "email");

    try {
      setEmailLoading(true);

      const can_id = normalizedCandidate?.candidate_id;

      await updateCandidate({
        ...getIdPayload(),
        data: {
          email_id: email,
        },
      });

      setOpenSuccess(true);
      fetchCandidate("basicDetails");

      setIsEmailIdEditing(false);
      setEmailState({ value: "", error: "" });

      setTimeout(() => setOpenSuccess(false), 2000);
    } catch (err) {
      console.error("Update Email Error:", err);
      alert("Something went wrong contact IT support");
    } finally {
      setEmailLoading(false);
    }
  };
  const normalizedCandidate = basicData;

  if (!normalizedCandidate) {
    return <Loader open={loading} fullScreen={true} />;
  }

  const fetchAdmins = async () => {
    try {
      const res = await getAdminIds({
        id: decryptedAdminID(),
        onlyMe: false,
      });

      // ✅ ensure array
      const list = Array.isArray(res) ? res : res?.data || res?.result || [];

      setAdminList(list);
    } catch (err) {
      console.error(err);
      setAdminList([]); // fallback
    }
  };

  const handleAdminChange = (_, value) => {
    console.log(value, "assignTo id");

    setSelectedAdmin(value);
  };
  const handleAssign = async () => {
    if (!selectedAdmin) {
      alert("Select admin");
      return;
    }

    try {
      setLoading(true);
      console.log(selectedAdmin.admin_id, "selectedAdmin.admin_id");

      await updateCandidate({
        ...getIdPayload(),
        data: {
          assign_to: selectedAdmin.admin_id,
        },
      });

      fetchCandidate("basicDetails");

      setAssignOpen(false);
      setSelectedAdmin(null);
    } catch (err) {
      console.error(err);
      alert("Assign failed");
    } finally {
      setLoading(false);
    }
  };
  const handleSourceUpdate = async () => {
    if (!selectedSource) {
      alert("Select source");
      return;
    }

    try {
      setLoading(true);

      await updateCandidate({
        ...getIdPayload(),
        data: {
          from_source: selectedSource, // ✅ send selected source
        },
      });

      fetchCandidate("basicDetails");

      setSourceOpen(false);
      setSelectedSource(null);
    } catch (err) {
      console.error(err);
      alert("Update failed");
    } finally {
      setLoading(false);
    }
  };
  // console.log(normalizedCandidate?.mobile_number,"normalizedCandidate?.mobile");

  // update form
  const handleopenCandidateUpdate = () => {
    handleupdateConfirmationOpen();
  };
  function handleupdateConfirmationOpen() {
    // console.log(candiate/Details,"candiateDetails");

    setoponUpdateFormNew(true);
    // GetCandidateQualifyForm(normalizedCandidate?.mobile_number)
    //   .then((data) => {
    //     if (data) {
    //       setSelectedOption(
    //         data?.candidateType === "Experienced" ? "experience" : "fresher",
    //       );
    //     } else {
    //       console.error("CanLeadDetails not available in data:", data);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching candidate details:", error);
    //   });
  }
  function handleCloseupdateForm() {
    setSelectedOption("");
    setoponUpdateForm(false);
    // getcandidateDetails(candidateId).then((data) => {
    //   setCandidateDetails(data);
    // });
    fetchCandidate("basicDetails");
  }
  function handleQualifyFormSubmit() {
    setOpenSuccess(true);

    setTimeout(() => {
      setOpenSuccess(false);
      setSelectedOption("");
      setoponUpdateForm(false);
    }, 1000);
    fetchCandidate("basicDetails");
  }
  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);

    let experiencedValue = false;
    if (selectedValue === "experience") {
      experiencedValue = true;
    }

    PutCandidateType(
      experiencedValue,
      normalizedCandidate?.mobile_number,
      "",
    ).then((data) => { });
  };


  const isActuallyRegistered =
    isLead &&
    normalizedCandidate?.is_registered === 1 &&
    normalizedCandidate?.registered_id;

  const effectiveIsLead = !isActuallyRegistered;

  const getIdPayload = () => {
    if (isActuallyRegistered) {
      return { can_id: normalizedCandidate?.registered_id };
    }

    return isLead
      ? { can_lead_id: normalizedCandidate?.id }
      : { can_id: normalizedCandidate?.candidate_id };
  };
  return (
    <>
      <div className={style.mainContainer}>
        <div className={style.DetailViewHeader}>
          {" "}
          <div className={style.title}>
            <FaArrowLeft onClick={onBack} />
            {isLead
              ? normalizedCandidate?.name
              : normalizedCandidate?.first_name}{" "}
            {normalizedCandidate?.last_name} Profile
          </div>
        </div>
        <div className={style.DetailViewSubHeader}>
          <div className={style.toggleWrapper}>
            <button
              className={`${style.tabButton} ${mainTab === "Overview" ? style.active : ""
                }`}
              onClick={() => setMainTab("Overview")}
            >
              Overview
            </button>
            <button
              className={`${style.tabButton} ${mainTab === "Timeline" ? style.active : ""
                }`}
              onClick={() => setMainTab("Timeline")}
            >
              Timeline
            </button>
          </div>
          <div className={style.SubHeaderAction}>
            <>
              {!isLead && (
                <div
                  className={`${style.movetoreg}`}
                  onClick={() => {
                    handleopenCandidateUpdate();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <LiaUserEditSolid style={{ fontSize: "18px" }} />

                  <span>Update</span>
                </div>
              )}
              {/* {!isLead && ( */}
                <div
                  className={`${style.infoButton}`}
                  onClick={() => setOpenFollowUp(true)}
                  style={{ cursor: "pointer" }}
                >
                  <IoAlarmOutline className="fs-5" />
                  <span>Create Follow Up</span>
                </div>
              {/* )}/ */}
              {!isLead && (
                <div className={`${style.primaryButton}`}>
                  <LuCalendarCheck2 className="fs-5" />{" "}
                  <ScheduleInterview
                    interviewDate={""}
                    candidateId={id}
                    showPopup={false}
                  />
                </div>
              )}

              <div>
                <BsWhatsapp
                  onClick={() =>
                    openWhatsApp(
                      normalizedCandidate?.whatsapp,
                      "Hi, I saw your profile.",
                    )
                  }
                />
              </div>
              <div>
                <span>
                  <MdOutlineLocalPhone
                    onClick={() =>
                      dialPhoneNumber(normalizedCandidate?.mobile_number)
                    }
                  />
                </span>
              </div>
            </>
          </div>
        </div>

        <div className={style.overview}>
          {/* interview Progress */}

          <div className={style.container}>
            <div className={style.candidateLayout}>
              <div className={style.leftPane}>
                <div className={style.DetailsViewBasicContainer}>
                  <div className={style.DetailsBasicHeader}>
                    <div className={style.division1}>
                      {" "}
                      <span className={style.divisionHeader}>
                        Candidate Basic Info
                      </span>
                    </div>
                    <div
                      className={style.division1}
                      style={{ position: "relative" }}
                    >
                      <BsThreeDotsVertical
                        onClick={(e) =>
                          handleMenuClick(e, normalizedCandidate.assign_to)
                        } // ✅ pass admin_id
                        style={{ cursor: "pointer" }}
                      />

                      <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <div style={{ padding: "10px", minWidth: "180px" }}>
                          <MenuItem
                            onClick={() => {
                              handleClose();
                              setIsEmailIdEditing(true);
                            }}
                          >
                            Update Email
                          </MenuItem>

                          {(isSuperAdmin || isTeamLeader) && (
                            <>
                              {" "}
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  setAssignOpen(true);
                                  fetchAdmins();
                                }}
                              >
                                Assign To
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  setSourceOpen(true);
                                }}
                              >
                                Change Source
                              </MenuItem>{" "}
                            </>
                          )}
                        </div>
                      </Popover>
                    </div>
                  </div>
                  <div className={style.DetailViewBasicProfile}>
                    <div className={style.profile}>
                      <div className={style.profilePicAndDetails}>
                        <div
                          className={`${normalizedCandidate?.candidate_id
                              ? style.Profile_div1
                              : style.Profile_div
                            }`}
                        >
                          <div className={style.CandidateProfile}>
                            <div className={style.CandidateProfile1}>
                              <img
                                src={candiateImage}
                                alt=""
                                width={68}
                                height={68}
                                style={{
                                  borderRadius: "50%",
                                  padding: "1px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={style.profileNameAndRating}>
                          <div className={style.textPrimary}>
                            {isLead
                              ? normalizedCandidate?.name
                              : normalizedCandidate?.first_name}{" "}
                            {isLead
                              ? normalizedCandidate?.last_name
                              : normalizedCandidate?.last_name}
                          </div>
                          <div className={style.Candidatepoistion}>
                            {isLead
                              ? normalizedCandidate?.job_category
                              : normalizedCandidate?.job_category}
                          </div>
                        </div>
                        <div className={`mt-2 ${style.profileContact}`}>
                          <span>
                            <BsBriefcase />{" "}
                            <span className={style.span}>
                              {isLead
                                ? normalizedCandidate.exp_in_years === 0
                                  ? "Fresher"
                                  : normalizedCandidate?.exp_in_years +
                                  "." +
                                  normalizedCandidate?.exp_in_months +
                                  " years EXP"
                                : normalizedCandidate.experienced === 0
                                  ? "Fresher"
                                  : normalizedCandidate?.exp_in_years +
                                  "." +
                                  normalizedCandidate?.exp_in_months +
                                  " years EXP"}
                            </span>
                          </span>
                          <span>
                            <SlGraduation />{" "}
                            <span
                              className={style.span}
                              style={{ cursor: "pointer" }}
                            >
                              {normalizedCandidate?.qualification ||
                                "No Added Qualification"}
                            </span>
                          </span>
                          <span>
                            <IoLocationOutline />{" "}
                            <span className={style.span}>
                              {" "}
                              {normalizedCandidate?.city || "No Location Added"}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={style.profile}>
                      <div className={style.profileContact}>
                        <span>
                          <FiPhone />{" "}
                          <span
                            className={style.span}
                            // onClick={() => dialPhoneNumber(normalizedCandidate?.mobile)}
                            style={{ cursor: "pointer" }}
                          >
                            +91{" "}
                            {normalizedCandidate?.mobile_number ||
                              "No Mobile Number Added"}{" "}
                          </span>
                          <MdOutlineContentCopy
                            onClick={() =>
                              copyToClipboard(
                                normalizedCandidate?.mobile_number,
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </span>
                        <span>
                          <BiMessageRoundedDetail />{" "}
                          <span
                            className={style.span}
                            onClick={() =>
                              openWhatsApp(
                                normalizedCandidate?.whatsapp_number,
                                "Hi, I saw your profile.",
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            +91{" "}
                            {normalizedCandidate?.whatsapp_number ||
                              "No WhatsApp Number Added"}{" "}
                          </span>
                          <MdOutlineContentCopy
                            onClick={() =>
                              copyToClipboard(
                                normalizedCandidate?.whatsapp_number,
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </span>
                        <span>
                          <IoMailOutline className="me-1" />{" "}
                          <span className={style.span}>
                            {" "}
                            {textTruncate(normalizedCandidate?.email_id, 30) ||
                              "No Email Id"}{" "}
                          </span>
                          {normalizedCandidate?.email_id && (
                            <MdOutlineContentCopy
                              onClick={() =>
                                copyToClipboard(normalizedCandidate?.email_id)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </span>
                      </div>
                    </div>
                    <div className={style.profile}>
                      <div className={style.candidatelogDeatails}>
                        <span>
                          {isLead ? "Lead Generated on " : "Registered On"} :{" "}
                          {formatDateTime(
                            isLead
                              ? normalizedCandidate?.last_enquiry_at
                              : normalizedCandidate?.created_time,
                          )}
                        </span>
                        <span>
                          Source From : {normalizedCandidate?.from_source}
                        </span>
                        <div className={style.boderline}></div>
                        <div className={style.assignedToDetails}>
                          <span className="pt-1">
                            Assigned to :{" "}
                            <span className={style.assignedTo}>
                              <span
                                className={style.assignedToFirstLetter}
                                style={{ color: "#fff" }}
                              >
                                {normalizedCandidate?.assigned_user_name
                                  ?.charAt(0)
                                  ?.toUpperCase() || "?"}
                              </span>{" "}
                              <span className={style.adminname}>
                                {normalizedCandidate?.assigned_user_name ||
                                  "Unassigned"}
                              </span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={style.rightPane}>
                {mainTab === "Overview" ? (
                  <div>
                    <div className={style.tabsView}>
                      {mainTab === "Overview" ? (
                        <CandidateTabs
                          isLead={!isActuallyRegistered && isLead}
                          isRegisteredLead={isActuallyRegistered}
                          basicData={basicData}
                          resumeData={resumeData}
                          interviewData={interviewData}
                          activeTab={innerTab}
                          setActiveTab={setInnerTab}
                          refreshResume={refreshResume}
                          reloadInterviews={reloadInterviews}
                        />
                      ) : (
                        <p>Timeline Content</p>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={style.tabsTimeLineView}>
                    {/* <TimelineView candidateId={id} isLead={isLead} /> */}
                    <TimelineView
                      candidateId={
                        isActuallyRegistered
                          ? normalizedCandidate?.registered_id
                          : id
                      }
                      isLead={!isActuallyRegistered && isLead}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/*  */}
      </div>
      {openSuccess && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully"} />
          </ModalContainer>
        </MyModal>
      )}

      {openSuccessFollowUp && (
        <MyModal>
          <ModalContainer>
            <SuccessTick HeadText={"Successfully Follow Up Created"} />
          </ModalContainer>
        </MyModal>
      )}
      {isEmailIdEditing && (
        <MyModal>
          <ModalContainer>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <b>Update Email Id</b>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => setIsEmailIdEditing(false)}
                >
                  <AiOutlineClose />
                </button>
              </div>

              <div className="mt-2 d-flex align-items-center gap-2">
                <TextField
                  label="Email Id"
                  type="email"
                  fullWidth
                  value={emailState.value}
                  onChange={(e) => handleEmailChange(e.target.value)}
                  error={!!emailState.error}
                  helperText={emailState.error}
                />

                <button
                  className="btn fs-4"
                  onClick={handleEmailSubmit}
                  disabled={emailLoading}
                >
                  {emailLoading ? (
                    <IoMdCheckmarkCircle style={{ color: "#169c5035" }} />
                  ) : (
                    <IoMdCheckmarkCircle style={{ color: "#169c50" }} />
                  )}
                </button>
              </div>
            </div>
          </ModalContainer>
        </MyModal>
      )}
      {assignOpen && (
        <MyModal>
          <ModalContainer>
            <div>
              <div className="d-flex justify-content-between">
                <b>Assign To</b>
                <button
                  onClick={() => setAssignOpen(false)}
                  className={style.cancelButton}
                >
                  <AiOutlineClose />
                </button>
              </div>

              <div className="mt-3">
                <Autocomplete
                  options={adminList || []} // ✅ NEVER undefined
                  getOptionLabel={(opt) => opt?.user_name || ""}
                  value={selectedAdmin}
                  onChange={handleAdminChange}
                  getOptionDisabled={(option) =>
                    option.admin_id === currentAdminId
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Admin" />
                  )}
                />
              </div>

              <div className="mt-3 text-end">
                <button
                  onClick={handleAssign}
                  disabled={loading}
                  className={style.primaryButton}
                >
                  {loading ? "Assigning..." : "Assign"}
                </button>
              </div>
            </div>
          </ModalContainer>
        </MyModal>
      )}
      {openFollowUp && (
        <MyModal>
          <ModalContainer>
            <CreateFollowUp
            registered_id = {isActuallyRegistered ? normalizedCandidate?.registered_id : null}          
              candidateId={id}
              entityType={isLead ? "LEAD" : "REGISTERED"}
              candidateName={`${normalizedCandidate?.first_name} ${normalizedCandidate?.last_name}`}
              onCancel={() => setOpenFollowUp(false)} // Change from onClose to onCancel
              onSuccess={() => {
                setOpenFollowUp(false);
                setOpenSuccessFollowUp(true);
                setTimeout(() => setOpenSuccessFollowUp(false), 2000);
              }}
            />
          </ModalContainer>
        </MyModal>
      )}
      {sourceOpen && (
        <MyModal>
          <ModalContainer>
            <div>
              <div className="d-flex justify-content-between">
                <b>Change Source</b>
                <button
                  onClick={() => setSourceOpen(false)}
                  className={style.cancelButton}
                >
                  <AiOutlineClose />
                </button>
              </div>

              <div className="mt-3">
                <Autocomplete
                  options={sources || []}
                  value={selectedSource}
                  onChange={handleSourceChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Source" />
                  )}
                />
              </div>

              <div className="mt-3 text-end">
                <button
                  onClick={handleSourceUpdate}
                  disabled={loading}
                  className={style.primaryButton}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </ModalContainer>
        </MyModal>
      )}

      {oponUpdateForm && (
        <>
          <MyModal>
            <ModalContainer zIndex={1500}>
              <>
                <div>
                  <div
                    className={`container d-flex align-itmes-center justify-content-between`}
                  >
                    <div className="">
                      <p>
                        <b>Candidate qualify form</b>
                      </p>
                      <div className="d-flex">
                        {" "}
                        <div className={`me-2  ${style.radioInput}`}>
                          {/* <label className="form-check-label me-3"> */}
                          <input
                            type="radio"
                            name="fresher"
                            id="fresherYes"
                            value="fresher"
                            className={`form-check-input `}
                            checked={selectedOption === "fresher"}
                            onChange={handleOptionChange}
                          />
                          <label for="fresherYes">Fresher</label>
                          {/* </label> */}
                        </div>
                        <div className={`me-2  ${style.radioInput}`}>
                          <label className="form-check-label">
                            <input
                              type="radio"
                              name="experience"
                              id="experienceNo"
                              value="experience"
                              className={`form-check-input `}
                              checked={selectedOption === "experience"}
                              onChange={handleOptionChange}
                            />
                            <label for="experienceNo">Experience</label>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="ms-5">
                      <div
                        className="btn btn-outline-danger"
                        onClick={handleCloseupdateForm}
                      >
                        <AiOutlineClose />{" "}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div>
                      {selectedOption === "fresher" ? (
                        <>
                          {/* <div className={`${style.Container}`}> */}{" "}
                          <UpdateFresherForm
                            mobilenumber={normalizedCandidate?.mobile_number}
                            whatsappNumber={
                              normalizedCandidate?.whatsapp_number
                            }
                            Reloadpage={handleQualifyFormSubmit}
                          />
                          {/* </div> */}
                        </>
                      ) : selectedOption === "experience" ? (
                        // <ExperinenceWorkingform
                        //   mobilenumber={currentMetaDetail.mobileNumber}
                        // />
                        <UpdateExperienceForm
                          mobileNumber={normalizedCandidate?.mobile_number}
                          whatsappNumber={normalizedCandidate?.whatsapp_number}
                          Reloadpage={handleQualifyFormSubmit}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            </ModalContainer>
          </MyModal>
        </>
      )}
      {oponUpdateFormNew && (
        <MyModal>
          <ModalContainer
            zIndex={1500}>
            
              <div>
                <FormMainLayout
                  onClose={() => {
                    setoponUpdateFormNew(false);
                    // Optional: Refresh data after closing
                    fetchCandidate("basicDetails");
                  }}
                  // For candidate (registered user)
                  canId={candidateid || normalizedCandidate?.candidate_id || null}

                  // For lead (not registered yet)
                  leadId={canLeadid || normalizedCandidate?.id || null}

                  // Specify the type
                  dataType={candidateid || normalizedCandidate?.candidate_id ? 'candidate' : 'can_lead'}

                  // Optional: Start from specific step (1-5)
                  initialStep={1}
                />
              </div>
            
          </ModalContainer>
        </MyModal>
      )}
    </>


  );
}

export default DetailContainer;
